import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import Btn from '../../components/Btn';
import './projects.css';
import '../../grid.css';


const styles = {
    card: {
        minWidth: 100,
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
};


function ProjectSummary({
    project, authToken, createProjectToken, deleteProjectToken,
}) {
    const { id } = project.project;
    return (
        <div>
            <div className="col span-3-of-11 projectCard">
                <Card >
                    <CardContent>
                        <Typography variant="h5" component="h2" />
                        <p className="companyName">
                            {project.project.name}
                        </p>
                        <Typography color="textSecondary" gutterBottom>
                            {project.project.publicToken}
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Btn
                            to={`/simulator/${id}`}
                            size="small"
                            label="View"
                            className="navBtn"
                        />
                        {project.project.publicToken ?
                            <Btn
                                size="small"
                                className="navBtn"
                                label="Del Token"
                                onClick={() => deleteProjectToken(authToken, id)}
                            />
                            :
                            <Btn
                                size="small"
                                className="navBtn"
                                label="Get Token"
                                onClick={() => createProjectToken(authToken, id)}
                            />
                        }
                    </CardActions>
                </Card>
            </div>
        </div>
    );
}

ProjectSummary.propTypes = {
    project: PropTypes.object.isRequired,
    authToken: PropTypes.string.isRequired,
    createProjectToken: PropTypes.func.isRequired,
    deleteProjectToken: PropTypes.func.isRequired,
};

export default withStyles(styles)(ProjectSummary);



// WEBPACK FOOTER //
// ./src/containers/Projects/ProjectSummary.js